module.exports = __webpack_public_path__ + "img/S__3686517.90ecc533.jpg";